import { createContext, useContext, useEffect } from 'react';

interface LayoutChrome {
  setFooterHidden: (hidden: boolean) => void;
  setHeaderHidden: (hidden: boolean) => void;
}

const LayoutChromeContext = createContext<LayoutChrome>({
  setFooterHidden: () => {},
  setHeaderHidden: () => {},
});

export const LayoutChromeProvider = LayoutChromeContext.Provider;

export function useLayoutChrome(): LayoutChrome {
  return useContext(LayoutChromeContext);
}

/**
 * Hide the app footer for as long as `hidden` is true, restoring it on unmount so
 * a page cannot leave the chrome in a collapsed state behind it.
 */
export function useHideLayoutFooter(hidden: boolean): void {
  const { setFooterHidden } = useLayoutChrome();

  useEffect(() => {
    setFooterHidden(hidden);
  }, [hidden, setFooterHidden]);

  useEffect(() => () => setFooterHidden(false), [setFooterHidden]);
}

/** Give a focused flow the full canvas, restoring app navigation on exit. */
export function useHideLayoutHeader(hidden: boolean): void {
  const { setHeaderHidden } = useLayoutChrome();

  useEffect(() => {
    setHeaderHidden(hidden);
  }, [hidden, setHeaderHidden]);

  useEffect(() => () => setHeaderHidden(false), [setHeaderHidden]);
}
